import { FC } from 'react'

import Styles from '../HallOfFame.module.scss'
import { Badges } from '../../Badges'
import { getColor } from '../../../../../util/getColor'
import { formatNumber } from '../../../../../util/formatNumber'
import { arrayMove } from '../../../../../util/arrayMethods'
import { BitazzaText } from '../../../../../components'

interface Props {
    hallOfFameData: hallOfFame[]
}

export const Top3: FC<Props> = ({ hallOfFameData }) => {
    const data = [...hallOfFameData]
    const top3Data = arrayMove(data, 0, 1)

    const gerBorder = (rank: number) => {
        if (rank === 1) {
            return '2px solid #555133'
        } else if (rank === 0) {
            return '2px solid #4A5251'
        } else {
            return '2px solid #3F2E23'
        }
    }

    return (
        <div className={Styles.container}>
            {top3Data &&
                top3Data.map((badge: hallOfFame, index: number) => {
                    const pnl: any = badge.pnl_monthly_percent
                    return (
                        <div
                            key={index}
                            className={Styles.wrapper}
                            style={{
                                backgroundColor:
                                    index === 1 ? '#22224E' : '#13132C',
                                border: gerBorder(index),
                                borderRadius: '8px',
                            }}
                        >
                            <Badges
                                top3
                                label={
                                    index === 0
                                        ? badge.month_of_rank
                                        : undefined
                                }
                                color={getColor(pnl, true)}
                                type={'default'}
                                rank={`${formatNumber(
                                    pnl,
                                    false,
                                    true,
                                    true,
                                    false
                                )}%`}
                                name={`@${badge.btz_id}`}
                                highlighted={index === 1}
                            />

                            {index === 0 && badge.month_of_rank ? (
                                <div
                                    className={Styles.labelWrapper}
                                    style={{ top: '-12px' }}
                                >
                                    <BitazzaText
                                        content={badge.month_of_rank}
                                        color="#fff"
                                        format="t12"
                                        bold
                                    />
                                </div>
                            ) : null}
                        </div>
                    )
                })}
        </div>
    )
}
